import * as React from 'react'
import Fade from 'react-reveal/Fade'

const Title = ({ h2, h3, h4 }) => {
  return (
    <section className='section-title mt-5'>
      {h2 ? <h2>{h2}</h2> : ''}
      {h3 ? <h3>{h3}</h3> : ''}
      {h4 ? <h4>{h4}</h4> : ''}
      <Fade left>
        <div className='underline'></div>
      </Fade>
    </section>
  )
}
export default Title
